import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Boundingbox extends Component {
    constructor(props) {
        super(props);
        this.state = { background: {} };
    }
    componentDidMount() {
        const ctx = this.canvas.getContext('2d');

        const background = new Image();
        background.src = this.props.image;

        // Make sure the image is loaded first otherwise nothing will draw.
        background.onload = async () => {
            this.setState({
                background: {
                    src: background.src,
                    width: background.width,
                    height: background.height,
                },
            });

            if (this.canvas) {
                this.count++;
                this.canvas.width = background.width;
                this.canvas.height = background.height;
                ctx.drawImage(background, 0, 0);
                this.renderBoxes();
            }
        };
    }

    componentWillUnmount() {
        //   console.log('unmount');
    }

    UNSAFE_componentWillReceiveProps() {
        // const ctx = this.canvas.getContext('2d');
        // if (this.canvas) {
        //     ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        // }
        // if (
        //     this.canvas &&
        //     this.canvas.width !== this.state.background.width &&
        //     this.canvas.height !== this.state.background.height
        // ) {
        //     this.canvas.width = this.state.background.width;
        //     this.canvas.height = this.state.background.height;
        //     ctx.drawImage(this.state.background, 0, 0);
        //     this.renderBoxes(nextProps.boxes);
        // }
        // const background = new Image();
        // background.src = nextProps.options.base64Image
        //   s  ? 'data:image/png;base64,' + this.props.image
        //     : nextProps.image;
        // background.onload = () => {
        //     if (
        //         this.canvas &&
        //         this.canvas.width !== background.width &&
        //         this.canvas.height !== background.height
        //     ) {
        //         this.canvas.width = background.width;
        //         this.canvas.height = background.height;
        //         ctx.drawImage(background, 0, 0);
        //         this.renderBoxes(nextProps.boxes);
        //     }
        // };
        // ctx.drawImage(this.state.background.src, 0, 0);
        // this.renderBoxes(nextProps.boxes);
        // return true;
    }

    componentDidUpdate() {
        this.renderBoxes();
    }

    renderBox(box) {
        if (!box || typeof box === 'undefined') return null;

        let lineWidth = 2;
        if (this.canvas) {
            if (this.canvas.width > 600) {
                lineWidth = 3;
            }
            if (this.canvas.width > 1000) {
                lineWidth = 5;
            }
            this.props.drawBox(this.canvas, box, null, lineWidth, this.state);
        }
    }

    renderBoxes(boxes) {
        if (typeof boxes === 'undefined') boxes = this.props.boxes;

        if (boxes === null) boxes = [];

        boxes
            .map((box, index) => {
                return { box, index };
            })
            .sort((a) => {
                return a.selected ? 1 : -1;
            })
            .forEach((box) => this.renderBox(box.box, box.index));
    }

    render() {
        return (
            <div className={this.props.className}>
                <canvas
                    className="boundingBoxCanvas"
                    style={this.props.options.style}
                    ref={(canvas) => {
                        this.canvas = canvas;
                    }}
                />
            </div>
        );
    }
}

Boundingbox.propTypes = {
    image: PropTypes.string,
    boxes: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.array),
        PropTypes.arrayOf(PropTypes.object),
    ]),
    selectedIndex: PropTypes.number,
    drawBox: PropTypes.func,
    drawLabel: PropTypes.func,
    onSelected: PropTypes.func,
    options: PropTypes.shape({
        colors: PropTypes.shape({
            normal: PropTypes.string,
            selected: PropTypes.string,
            unselected: PropTypes.string,
        }),
        style: PropTypes.object,
        base64Image: PropTypes.bool,
    }),
    className: PropTypes.string,
};

Boundingbox.defaultProps = {
    boxes: [],
    drawBox(canvas, box, color, lineWidth, state) {
        if (!box || typeof box === 'undefined') return null;

        const ctx = canvas.getContext('2d');

        const coord = box.coord ? box.coord : box;

        let [x, y, width, height] = [0, 0, 0, 0];

        if (
            typeof coord.xmin !== 'undefined' &&
            typeof coord.xmax !== 'undefined' &&
            typeof coord.ymin !== 'undefined' &&
            typeof coord.ymax !== 'undefined'
        ) {
            // coord is an object containing xmin, xmax, ymin, ymax attributes
            // width is absolute value of (xmax - xmin)
            // height is absolute value of (ymax - ymin)
            // absolute value takes care of various possible referentials:
            //   - sometimes 0,0 is top-left corner
            //   - sometimes 0,0 is bottom-left corner
            [x, y, width, height] = [
                Math.min(coord.xmin, coord.xmax),
                Math.min(coord.ymin, coord.ymax),
                Math.max(coord.xmin, coord.xmax) -
                    Math.min(coord.xmin, coord.xmax),
                Math.max(coord.ymin, coord.ymax) -
                    Math.min(coord.ymin, coord.ymax),
            ];
        } else {
            // coord is an array containing [x, y, width, height] values
            [x, y, width, height] = coord;
        }
        const { background } = state;

        x = x * (background && background.width ? background.width : 1200);
        y = y * (background && background.height ? background.height : 1200);
        width =
            width * (background && background.width ? background.width : 1200);
        height =
            height *
            (background && background.height ? background.height : 1200);

        if (x < lineWidth / 2) {
            x = lineWidth / 2;
        }
        if (y < lineWidth / 2) {
            y = lineWidth / 2;
        }

        if (x + width > canvas.width) {
            width = canvas.width - lineWidth - x;
        }
        if (y + height > canvas.height) {
            height = canvas.height - lineWidth - y;
        }
        ctx.beginPath();
        ctx.strokeStyle = '#f3f624';
        ctx.lineWidth = lineWidth;
        ctx.rect(x, y, width, height);
        ctx.stroke();
    },
    drawLabel(canvas, box) {
        if (!box || typeof box === 'undefined') return null;

        const ctx = canvas.getContext('2d');

        const coord = box.coord ? box.coord : box;

        // eslint-disable-next-line no-unused-vars
        let [x, y, width, height] = [0, 0, 0, 0];

        if (
            typeof coord.xmin !== 'undefined' &&
            typeof coord.xmax !== 'undefined' &&
            typeof coord.ymin !== 'undefined' &&
            typeof coord.ymax !== 'undefined'
        ) {
            // coord is an object containing xmin, xmax, ymin, ymax attributes
            // width is absolute value of (xmax - xmin)
            // height is absolute value of (ymax - ymin)
            // absolute value takes care of various possible referentials:
            //   - sometimes 0,0 is top-left corner
            //   - sometimes 0,0 is bottom-left corner
            [x, y, width, height] = [
                Math.min(coord.xmin, coord.xmax),
                Math.min(coord.ymin, coord.ymax),
                Math.max(coord.xmin, coord.xmax) -
                    Math.min(coord.xmin, coord.xmax),
                Math.max(coord.ymin, coord.ymax) -
                    Math.min(coord.ymin, coord.ymax),
            ];
        } else {
            // coord is an array containing [x, y, width, height] values
            [x, y, width, height] = coord;
        }

        ctx.font = '60px Arial';
        ctx.fillStyle = 'rgba(225,0,0,1)';
        ctx.fillText(box.label, x, y + height);
    },
    options: {
        colors: {
            normal: 'rgba(255,225,255,1)',
            selected: 'rgba(0,225,204,1)',
            unselected: 'rgba(100,100,100,1)',
        },
        style: {
            maxWidth: '100%',
            maxHeight: '90vh',
        },
        base64Image: false,
    },
};

export default Boundingbox;
